<template>
    <div :id="`swiper-${id}`" class="swiper-container" v-if="data && data.length">
        <el-carousel ref="carouselRef" trigger="click" :height="carouselHeight" arrow="always" :initial-index="data.length - 1" :autoplay="false" :loop="false"
            indicator-position="none">
            <el-carousel-item v-for="item in data" :key="item.id" class="slide-item">
                <div>学校历史拜访</div>
                <div>拜访日期：{{ item.visitDay }}</div>
                <div>拜访联系人：
                    <template v-for="(person, pInd) in item.logPeopleModelList">{{ person.peopleName }} <!-- 名字 -->
                        <template v-if="person.positionStr">({{ person.positionStr }})</template> <!-- 职位 -->
                        <template v-if="(pInd + 1) < item.logPeopleModelList.length">/ </template> <!-- 分隔符 -->
                    </template>
                </div>
                <div>拜访目的：{{ item.target }}</div>
                <div>拜访结果：{{ item.result }}</div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    name: 'lastLogs',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        id: String
    },
    data() {
        return {
            swiperInstance: null,
            carouselHeight: '150px',
        }
    },
    watch: {
        data: {
            handler(val) {
                if (val && val.length) {
                    this.$nextTick(() => {
                        this.adjustCarouselHeight();
                    })
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        // 计算轮播图中的最大高度
        adjustCarouselHeight() {
            let slideDoms = this.$refs.carouselRef.$el.querySelectorAll('.el-carousel__container .slide-item');
            let heights = [];
            slideDoms.forEach(i => {
                heights.push(i.clientHeight);
            })

            this.carouselHeight = `${Math.max(...heights)}px`;
            this.$refs.carouselRef.$el.querySelector('.el-carousel__container').style.height = this.carouselHeight;
        }
    }
}
</script>

<style lang="scss" scoped>
.swiper-container {
    width: 100%;
    background: #f0efef;
    border-radius: 6px;
    .slide-item {
        width: 100%;
        height: fit-content;
        padding: 10px 35px 15px 35px;
        overflow: hidden;
        > div:not(:first-of-type) {
            color: #666666;
            font-size: 0.86rem;
            line-height: 1.6;
        }
    }
    ::v-deep .el-carousel .el-carousel__arrow--right {
        right: 0;
        font-size: 20px;
    }
    ::v-deep .el-carousel .el-carousel__arrow--left {
        left: 0;
        font-size: 20px;
    }
}
</style>